declare var nsjGlobals: any;
import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { MeurhAdmissaoestagiarioService } from '../admissaoestagiario.service';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { MeurhAnexosService } from '../../Anexos/anexos.service';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { SituacaoAdmissaoEnum } from '../enums/situacao';
import { TipoRecebimentobolsaEnum } from '../enums/tiporecebimentobolsa.enum';
import { StatusProcessoEnum } from '../enums/statusprocesso.enum';
import { IGestoresTrabalhador } from '../../Transferenciacolaboradores/models/transferenciacolaboradores.model';
import { MeurhAcompanhamentoService } from '../../Acompanhamento/acompanhamento.service';
import { validaNis } from '../utils';

export class MeurhAdmissaoestagiarioEditController implements ng.IController {
    static $inject = [
        '$scope',
        '$stateParams',
        '$state',
        'MeurhAdmissaoestagiarioService',
        'entity',
        'NewToaster',
        'TiposDocumentosRequeridosService',
        '$q',
        'MeurhAnexosService',
        '$rootScope',
        'ModalConfirmService',
        'MeurhAcompanhamentoService',
    ];

    public constructors: any = {};
    public action = 'update';
    public tipo = this.$stateParams['tipo'];
    public form: angular.IFormController;
    public busy: boolean = false;
    public entitySave: any = {};
    public dataAtual = new Date();
    public matriculaAutomatica: boolean = false;
    public toastController = {
        podeEnviar: false,
        podeEncaminhar: false
    };

    public mostrarAlertaDocumentosAnexos: boolean = false;
    public desativaportrabalhadortemporario: boolean = false;
    public mostraobrigatoriosencaminhar: boolean = false;
    public tiposdocumentosrequeridos: Array<any> = [];
    public validate: number = 0;
    public busyTipoDocumentos: boolean = true;
    public entityAnexo: IAnexo = {};
    public formAnexo: angular.IFormController;
    public editanexo: boolean = true;
    public adicionarAnexo: boolean = false;
    public actionAnexo: string = 'update';
    public alterouanexo: boolean = false;
    public documentosValidados: boolean = false;
    public clienteAna: boolean;
    public idsCards: Array<string> = [
        'card-dadosgerais',
        'card-docsanexos',
        'card-endereco',
        'card-dadoscontato',
        'card-dadospessoais',
        'card-documentacao',
        'card-outrasinfos',
        'card-observacoes',
        'card-beneficios',
        'card-dependentes',
        'card-valestransporte',
    ];

    private situacaoAdmissaoEnum = SituacaoAdmissaoEnum;
    private tipoRecebimentobolsaEnum = TipoRecebimentobolsaEnum;
    private statusprocessoEnum = StatusProcessoEnum;

    constructor(
        private $scope: angular.IScope,
        private $stateParams: angular.ui.IStateParamsService,
        private $state: angular.ui.IStateService,
        private entityService: MeurhAdmissaoestagiarioService,
        private entity: any,
        private NewToaster: any,
        private TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
        private $q: angular.IQService,
        private MeurhAnexosService: MeurhAnexosService,
        public $rootScope: angular.IRootScopeService & {
            nsjGlobals: any,
            configuracoes: any,
            codigoHook: number | string,
            liberadoTela: (param: string) => boolean
            temPermissao: (param: string) => boolean
        },
        private ModalConfirmService: any,
        private MeurhAcompanhamentoService: MeurhAcompanhamentoService,
    ) {

        this.MeurhAcompanhamentoService.constructors.solicitacao = this.entity.solicitacao;
        this.MeurhAcompanhamentoService.reload();

        // documentos / anexos
        this.resetTiposDocumentosRequeridosService();
        this.podeEnviarObserver();
        this.podeEncaminharObserver();
        this.onSubmitSuccess();
        this.onSubmitError();
        this.clienteAna = nsjGlobals.get('clienteana');
        this.entity.gestaoBeneficioAvancadaAtiva = this.$rootScope.nsjGlobals.a.configuracoes.GESTAO_BENEFICIO_AVANCADA_ATIVA;
    }

    async $onInit(): Promise<void> {
        if (this.$rootScope.configuracoes.CODIGO_FUNCIONARIO_AUTOMATICO === true) {
            this.matriculaAutomatica = true;
        }

        this.entity.tipocategoriatrabalhador = { 'tipocolaborador': '2' }; // tipo estagiário

        this.busy = true;

        this.entityService.getFoto(this.entity.solicitacao)
        .then(() => {
            this.busy = false;
        })
        .catch(() => {
            this.busy = false;
        });

        this.entityAnexo['solicitacao'] = this.entity.solicitacao;
        this.entityAnexo['casodeuso'] = 'ADMISSOESESTAGIARIO';
        this.alteraEntityInicio();

        if (
            this.entity.statusprocesso === this.statusprocessoEnum.ENVIADA ||
            this.entity.statusprocesso === this.statusprocessoEnum.EM_ACOMPANHAMENTO
        ) {
            this.editanexo = false;
        }

        // carregamento dos tipos de documentos requeridos
        await this.TiposDocumentosRequeridosService._load(this.TiposDocumentosRequeridosService.constructors, this.TiposDocumentosRequeridosService.after, '')
        .then((documentosCarregados: any) => {
            this.tiposdocumentosrequeridos = documentosCarregados;
            this.busyTipoDocumentos = false;
            this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
                tipodocumentorequerido.validateResult = false;
                tipodocumentorequerido.fileSelecionado = false;
                return tipodocumentorequerido;
            });

        })
        .catch((error) => {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível carregar os tipos de documentos',
                body: 'Não foi possível carregar os tipos de documentos requeridos para a admissão',
                timeout: 4000
            });
            this.busyTipoDocumentos = false;
        });

        if (this.$stateParams['camposobrigatorios'] === '1') {
            this.mostrarObrigatoriosEnviar();
        }

    }

    // início - use cases
    public submit(rascunho: boolean = false): void {

        // se estiver apenas salvando um rascunho, não precisa de uma modal de confirmação
        if (rascunho) {

            this.busy = true;
            this.form.$submitted = true;

            if (!!this.podeSalvarRascunho()) {
                this.alteraEntityEnviar(rascunho);
                this.entityService.save(this.entitySave);
            } else {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Alguns campos do formulário apresentam erros',
                    body: 'Favor verificar os campos sinalizados com erro.'
                });

                this.busy = false;
            }

        } else { // enviando admissão

            const customText = this.getMensagensModal('enviar');
            const confirm = this.ModalConfirmService.open(this.entity, 'Admissão', false, customText);

            confirm.result.then((): void => {
                this.busy = true;
                this.form.$submitted = true;

                if (!this.entity.$$__submitting && this.validaEntityEnviar()) {
                    this.alteraEntityEnviar(rascunho);
                    this.entityService.save(this.entitySave);
                } else {
                    this.mostrarObrigatoriosEnviar();

                    if (!this.validaDocumentosAnexos()) {
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Há documento(s) obrigatório(s) não informado(s)'
                        });
                    } else {
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Alguns campos do formulário apresentam erros',
                            body: 'Favor verificar os campos sinalizados com erro.'
                        });
                    }

                    this.busy = false;
                }
            })
            .catch(function () {/**/ });
        }
    }

    public encaminhar(opt?: string): void {
        const customText = this.getMensagensModal('encaminhar');
        const confirm = this.ModalConfirmService.open(this.entity, 'Admissão', false, customText);

        confirm.result
            .then(async (): Promise<void> => {
                this.busy = true;
                this.constructors.solicitacao = this.entity.solicitacao;

                await this.entityService.encaminhar(this.entity.solicitacao, opt)
                    .then((encaminharResponse: ng.IHttpResponse<any>) => {
                        const titleMessage = opt
                            ? 'Código gerado com sucesso'
                            : 'A admissão foi encaminhada com sucesso.';

                        const bodyMessage = opt
                            ? 'O código da admissão foi copiado, você já pode colar onde quiser para mandar para o futuro colaborador.'
                            : null;

                        this.NewToaster.pop({
                            type: 'success',
                            title: titleMessage,
                            body: bodyMessage
                        });

                        if (!!encaminharResponse.data.codigoverificacao) {
                            navigator.clipboard.writeText(encaminharResponse.data.codigoverificacao);
                        } else {
                            this.$state.go('meurh_admissaoestagiario_show', this.constructors);
                        }
                    })
                    .catch(() => {
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Ocorreu um erro ao encaminhar a admissão para o aplicativo'
                        });
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            })
            .catch(() => {/** */ });
    }

    public descartar(): void {
        let confirm = this.ModalConfirmService.OpenDescartar(this.entity, 'edição', true, 'admissao');

        confirm.result
            .then((): void => {
                this.busy = true;
                this.$state.go('meurh_admissaoestagiario_show', { 'solicitacao': this.entity.solicitacao });
            })
            .catch(function () {/**/ });
    }
    // fim - use cases


    // início - controle de estilização dinâmica
    public getSituacaoLabel(): string {
        if (this.entity.situacao === this.situacaoAdmissaoEnum.ABERTA) {
            return 'label label-aberta';
        }

        if (this.entity.situacao === this.situacaoAdmissaoEnum.ENVIADA) {
            return 'label label-warning';
        }

        if (this.entity.situacao === this.situacaoAdmissaoEnum.EFETUADA) {
            return 'label label-success';
        }

        if (
            this.entity.situacao === this.situacaoAdmissaoEnum.CANCELADA ||
            this.entity.situacao === this.situacaoAdmissaoEnum.EXCLUIDA ||
            this.entity.situacao === this.situacaoAdmissaoEnum.RECUSADA
        ) {
            return 'label label-danger';
        }

        return '';
    }

    public getSituacaoBindTemplate(): string {

        if (this.entity.wkf_estado) {
            return this.entity.wkf_estado;
        }

        switch (this.entity.situacao) {
            case this.situacaoAdmissaoEnum.ABERTA:
                return 'Aberta';

            case this.situacaoAdmissaoEnum.ENVIADA:
                return 'Enviada';

            case this.situacaoAdmissaoEnum.EFETUADA:
                return 'Efetuada';

            case this.situacaoAdmissaoEnum.CANCELADA:
                return 'Cancelada';

            case this.situacaoAdmissaoEnum.EXCLUIDA:
                return 'Excluída';

            case this.situacaoAdmissaoEnum.RECUSADA:
                return 'Recusada';

            default:
                return ' - ';
        }
    }

    public getSituacaoEncaminhadaBindTemplate(): string {
        let stringLabel: string = '';

        if (
            this.entity.situacao !== this.situacaoAdmissaoEnum.EXCLUIDA &&
            (
                this.entity.statusprocesso === this.statusprocessoEnum.ENVIADA ||
                this.entity.statusprocesso === this.statusprocessoEnum.EM_ACOMPANHAMENTO
            )
        ) {
            stringLabel = 'encaminhada';
        }

        return stringLabel;
    }
    // fim - controle de estilização dinâmica


    // início - controle de botões e campos
    public podeEnviar(): boolean {
        const podeEnviar = this.validaEntityEnviar();

        this.toastController.podeEnviar = podeEnviar;

        return podeEnviar && this.$rootScope.temPermissao('criar_admissao_comp') && this.entity.situacao === this.situacaoAdmissaoEnum.ABERTA;
    }

    public podeSalvarRascunho(): boolean {
        if (this.entity.situacao === this.situacaoAdmissaoEnum.ENVIADA && this.entity._editavel) {
            return this.validaEntityEnviar() && this.$rootScope.temPermissao('criar_admissao_comp');
        } else {
            return (
                this.form.nome.$valid &&
                this.validaAmbienteTrabalho() &&
                this.validaDadosBancarios() &&
                this.$rootScope.temPermissao('criar_admissao_comp')
            );
        }

    }
    public podeEncaminhar(): boolean {
        const podeEncaminhar = this.mostrarEncaminhar() && this.validaEncaminhar();

        this.toastController.podeEncaminhar = podeEncaminhar;

        return this.toastController.podeEncaminhar && this.podeSalvarRascunho();
    }

    public podeEnviarEmail(): boolean {
        return (
            this.entity.situacao === this.situacaoAdmissaoEnum.ABERTA &&
            this.entity.statusprocesso !== this.statusprocessoEnum.FINALIZADA &&
            this.entity.statusprocesso !== this.statusprocessoEnum.RETOMADA
        );
    }

    public mostrarObrigatoriosEnviar(): void {
        setTimeout(() => {
            if (this.form) {
                this.expandirCardsObrigatorios();
                this.form.$setPristine();
                this.form.$setSubmitted();
            }
            this.$scope.$applyAsync();
        }, 100);

        this.mostrarAlertaDocumentosAnexos = true;
        this.mostraobrigatoriosencaminhar = false;
    }

    public mostrarEncaminhar(): boolean {
        return (
            this.$rootScope.temPermissao('criar_admissao_comp') &&
            this.$rootScope.liberadoTela('LIBERAR_SOL_ADMISSAO_ENCAMINHAR') &&
            this.entity.statusprocesso !== this.statusprocessoEnum.FINALIZADA &&
            this.entity.statusprocesso !== this.statusprocessoEnum.RETOMADA &&
            this.entity.situacao === this.situacaoAdmissaoEnum.ABERTA
        );
    }

    public mostrarObrigatoriosEncaminhar(): void {
        if (this.form) {
            this.form.$setPristine();
            this.form.matricula.$setDirty();
            this.form.nome.$setDirty();
            this.form.email.$setDirty();
            this.form.categoriatrabalhador.$setDirty();
            this.form.valorbolsa.$setDirty();
            this.form.cargo.$setDirty();
            this.form.nivelcargo.$setDirty();
            this.form.departamento.$setDirty();
            this.form.horario.$setDirty();
            this.form.lotacao.$setDirty();
            this.form.unidadebolsa.$setDirty();

            if (this.entity.vagaAtiva) {
                this.form.vaga.$setDirty();
            } else {
                this.form.estabelecimento.$setDirty();
            }
        }

        this.mostrarAlertaDocumentosAnexos = false;
        this.mostraobrigatoriosencaminhar = true;
    }
    // fim - controle de botões e campos


    // início - validações
    private validaEntityEnviar(): boolean {
        return (
            this.validaDadosGerais() &&
            this.validaEndereco() &&
            this.validaDadosContato() &&
            this.validaDadosPessoais() &&
            this.validaDocumentacao() &&
            this.validaDocumentosAnexos() &&
            this.validaOutrasInformacoes() &&
            this.validaTelefones()
        );
    }

    private validaEncaminhar(): boolean {
        return (
            this.validaMatricula() &&
            this.form.nome.$valid &&
            !!this.entity.email &&
            this.validaDadosVaga() &&
            this.validaDadosEmpresa() &&
            this.validaBolsa() &&
            this.validaOutrasInformacoesGerais() &&
            this.validaTelefones()
        );
    }

    private validaDadosGerais(): boolean {
        return (
            this.validaIdentificacao() &&
            this.validaDadosVaga() &&
            this.validaAmbienteTrabalho() &&
            this.validaDadosEmpresa() &&
            this.validaContrato() &&
            this.validaPeriodos() &&
            this.validaBolsa() &&
            this.validaOutrasInformacoesGerais()
        );
    }

    private validaIdentificacao(): boolean {
        const emailValid = this.validaEmail();

        return (
            this.validaMatricula() &&
            this.form.nome.$valid &&
            this.form.cpf.$valid &&
            !!this.entity.datanascimento &&
            emailValid
        );
    }

    private validaMatricula(): boolean {
        return (
            this.matriculaAutomatica ||
            !!this.entity.matricula
        );
    }

    private validaEmail(): boolean {
        return (
            !!this.entity.emailcorporativo ||
            !!this.entity.email
        );
    }

    private validaDadosVaga(): boolean {
        return (
            !!this.entity.vagaAtiva === !!this.entity.vaga &&
            !!this.entity.cargo &&
            !!this.entity.nivelcargo
        );
    }

    private validaAmbienteTrabalho(): boolean {
        return (
            !this.entity.ambiente ||
            !!this.entity.condicaoambientetrabalho
        );
    }

    private validaDadosEmpresa(): boolean {
        return (
            !!this.entity.estabelecimento &&
            !!this.entity.departamento &&
            !!this.entity.lotacao
        );
    }

    private validaContrato(): boolean {
        return (
            !!this.entity.datainiciocontrato &&
            !!this.entity.datafimcontrato
        );
    }

    private validaPeriodos(): boolean {
        return !(
            !(!!this.entity.numerodiasperiodo) ||
            this.entity.numerodiasperiodo > 31 ||
            !(!!this.entity.numerohorasmensais) ||
            !(!!this.entity.quantidademediahorassemanais)
        );
    }

    private validaBolsa(): boolean {
        return (
            !!this.entity.valorbolsa &&
            !!this.entity.unidadebolsa
        );
    }

    private validaOutrasInformacoesGerais(): boolean {
        return (
            !!this.entity.categoriatrabalhador &&
            !!this.entity.atividade &&
            !!this.entity.horario
        );
    }

    private validaEndereco(): boolean {
        return (
            !!this.entity.cep &&
            !!this.entity.tipologradouro &&
            !!this.entity.logradouro &&
            !!this.entity.numero &&
            !!this.entity.municipio &&
            !!this.entity.pais
        );
    }

    private validaDadosContato(): boolean {
        return this.validaTelefonesDeContato();
    }

    private validaTelefonesDeContato(): boolean {
        return (
            this.validaTelefoneFixo() &&
            this.validaCelular() &&
            this.validaTelefoneDeEmergencia()
        );
    }

    private validaTelefones(): boolean {
        return this.validaTelefonesDeContato() && this.validaTelefoneCorporativo();
    }

    private validaTelefoneFixo(): boolean {
        return (
            this.form.dddtel.$valid &&
            this.form.telefone.$valid
        );
    }

    private validaCelular(): boolean {
        return (
            this.form.dddcel.$valid &&
            this.form.celular.$valid
        );
    }

    private validaTelefoneCorporativo(): boolean {
        return (
            this.form.dddtelcorporativo.$valid &&
            this.form.telefonecorporativo.$valid
        );
    }

    private validaTelefoneDeEmergencia(): boolean {
        return (
            this.form.dddtelemergencia.$valid &&
            this.form.telefoneemergencia.$valid
        );
    }

    private validaDadosPessoais(): boolean {
        return (
            this.validaNascimento() &&
            this.validaIdentificacaoDadosPessoais()
        );
    }

    private validaNascimento(): boolean {

        let infosValidasPaisEstrangeiro: boolean = false;

        if (this.entity.paisnascimento) {
            if (this.entity.paisnascimento.pais !== '1058') {
                infosValidasPaisEstrangeiro = !!this.entity.datachegadapais && !!this.entity.temporesidenciaestrangeiro && !!this.entity.classificacaoestrangeiro;
            } else if (this.entity.paisnascimento.pais === '1058') {
                infosValidasPaisEstrangeiro = true;
            }
        }

        return (
            !!this.entity.municipionascimento &&
            !!this.entity.paisnascimento &&
            !!this.entity.paisnacionalidade &&
            infosValidasPaisEstrangeiro
        );
    }

    private validaIdentificacaoDadosPessoais(): boolean {

        let validacoesClienteAna = true;

        if (this.clienteAna && !this.entity.semfiliacao) {
            validacoesClienteAna = !!this.entity.nomemae || !!this.entity.nomepai;
        }

        return (
            !!this.entity.sexo &&
            !!this.entity.estadocivil &&
            !!this.entity.raca &&
            !!this.entity.grauinstrucao &&
            validacoesClienteAna
        );
    }

    private validaDocumentacao(): boolean {
        return (
            this.validaDocumentacaoObrigatoria() &&
            this.validaCtps()
        );
    }

    private validaDocumentacaoObrigatoria(): boolean {
        return this.verificaNis();
    }

    private verificaNis(): boolean {
        return validaNis(this.entity.nis, this.form);
    }

    private validaCtps(): boolean {
        return !(!!this.entity.numeroctps && !(!!this.entity.ufctps));
    }

    private validaDocumentosAnexos(): boolean {
        if (this.busyTipoDocumentos) {
            return false;
        } else {
            return this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
                return (tipodocumentorequerido.fileSelecionado === ( tipodocumentorequerido.obrigatorio || tipodocumentorequerido.fileSelecionado));
            });
        }
    }

    private validaOutrasInformacoes(): boolean {
        return (
            this.validaInformacoesGerais() &&
            this.validaFerias() &&
            this.validaRecebimento() &&
            this.validaEstagio()
        );
    }

    private validaInformacoesGerais(): boolean {
        return (
            !!this.entity.datavencimentoatestadomedico &&
            !!this.form.percentualadiantamento.$error &&
            this.validaPercentualAdiantamento(this.entity.percentualadiantamento)
        );
    }

    private validaPercentualAdiantamento(percentual: number): boolean {
        const PERCENTUAL_MIN = 0;
        const PERCENTUAL_MAX = 0.5;

        return percentual >= PERCENTUAL_MIN && percentual <= PERCENTUAL_MAX;
    }

    private validaFerias(): boolean {
        return !!this.entity.inicioperiodoaquisitivoferias;
    }

    private validaRecebimento(): boolean {
        return (
            this.entity.tiporecebimentobolsa &&
            this.validaDadosBancarios() &&
            this.validaDadosPix()
        );
    }

    private validaDadosBancarios(): boolean {
        if (
            !this.entity.semdadosbancarios &&
            (
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_CORRENTE ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_POUPANCA ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_SALARIO ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_AGENCIA_CONTA
            )
        ) {

            let tipoContaPixValida: boolean = true;

            if (this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_AGENCIA_CONTA && !(!!this.entity.tipocontapix)) {
                tipoContaPixValida = false;
            }

            return (
                !!this.entity.banco &&
                (!!this.entity.agencia || !!this.entity.agencianumero) &&
                !!this.entity.numerocontasalario &&
                !!this.entity.numerocontasalariodv &&
                tipoContaPixValida
            );
        }
        return true;
    }

    private validaDadosPix(): boolean {
        if (
            this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CPF ||
            this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_EMAIL ||
            this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CELULAR ||
            this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CHAVE_ALEATORIA
        ) {
            return !!this.entity.chavepix && this.form.chavepix?.$valid;
        }
        return true;
    }

    private validaEstagio(): boolean {
        return (
            !!this.entity.nivelestagio &&
            !!this.entity.instituicaoensino
        );
    }

    private expandirCardsObrigatorios(): void {
        this.idsCards.forEach((idCard) => {
            this.verificaExpansaoCard(idCard);
        });
    }

    private alternaExpansaoCard(card: any, deveExpandir: boolean): void {
        deveExpandir ? card.open() : card.close();
    }

    /**
     * Recebe o identificador do card e verifica se o mesmo deverá ser expandido para mostrar campos obrigatórios não preenchidos ou não.
     * Os métodos open e close chamados são referentes aos métodos do componente accordion.
     * @param idCard Identificador do card, definido no html da página.
     */
    private verificaExpansaoCard(idCard: string): void {
        let card: any = document.getElementById(idCard);

        if (!card) {
            return;
        }

        switch (idCard) {
            case 'card-dadosgerais':
                this.alternaExpansaoCard(card, !this.validaDadosGerais());
                break;

            case 'card-docsanexos':
                this.alternaExpansaoCard(card, !this.validaDocumentosAnexos());
                break;

            case 'card-endereco':
                this.alternaExpansaoCard(card, !this.validaEndereco());
                break;

            case 'card-dadoscontato':
                this.alternaExpansaoCard(card, !this.validaDadosContato());
                break;

            case 'card-dadospessoais':
                this.alternaExpansaoCard(card, !this.validaDadosPessoais());
                break;

            case 'card-documentacao':
                this.alternaExpansaoCard(card, !this.validaDocumentacao());
                break;

            case 'card-outrasinfos':
                this.alternaExpansaoCard(card, !this.validaOutrasInformacoes());
                break;

            default:
                card.close();
                break;
        }
    }
    // fim - validações


    // início - observers
    private podeEnviarObserver(): void {
        this.$scope.$watch('mrh_admssstgr_frm_edit_cntrllr.toastController.podeEnviar', function (newValue: any, oldValue: any) {

            let documentosValidos: boolean = this.busyTipoDocumentos ? false : (this.tiposdocumentosrequeridos.length > 0 ? this.validaDocumentosAnexos() : true);

            if (newValue === true && this.entity.situacao === -1 && documentosValidos) {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'A admissão já pode ser enviada',
                    body: 'Todos os dados obrigatórios já foram informados.',
                    timeout: 4000
                });
            }
        }.bind(this), true);
    }

    private podeEncaminharObserver(): void {
        this.$scope.$watch('mrh_admssstgr_frm_edit_cntrllr.toastController.podeEncaminhar', function (newValue: any, oldValue: any) {
            if (!!newValue && this.entity.statusprocesso === this.statusprocessoEnum.NAO_ENCAMINHADA) {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'A admissão já pode ser encaminhada',
                    body: 'Já é possível encaminhar a admissão para o futuro colaborador informar os dados pelo app.',
                    timeout: 4000
                });
            }
        }.bind(this), true);
    }

    private uploadDocumentosDependentes(solicitacao: string, solicitacaohistorico?: string): angular.IPromise<any> {
        const uploads: Array<angular.IPromise<any>> = [];
        const dependentes = this.entity.dependentes || [];

        dependentes.forEach((dependente: any) => {
            const documentos = dependente.tiposdocumentosrequeridosdependentes || [];

            documentos.forEach((tipodocumentorequerido: any) => {
                const upload = this.uploadDocumentoDependente(solicitacao, dependente, tipodocumentorequerido, solicitacaohistorico);

                if (upload) {
                    uploads.push(upload);
                }
            });
        });

        return uploads.length > 0 ? this.$q.all(uploads) : this.$q.when([]);
    }

    private uploadDocumentoDependente(
        solicitacao: string,
        dependente: any,
        tipodocumentorequerido: any,
        solicitacaohistorico?: string
    ): angular.IPromise<any> | null {
        const file = tipodocumentorequerido.file;
        const arquivoRemovido = tipodocumentorequerido.arquivoRemovido;

        if ((!file || file.id) && !arquivoRemovido) {
            return null;
        }

        const rotaAnexo = 'meurh_solicitacoesadmissoesestagiario_documentos_';
        const estabelecimento = this.entity.estabelecimento?.estabelecimento || this.entity.estabelecimento;
        let promise = arquivoRemovido
            ? this.MeurhAnexosService.deleteAnexo({
                id: solicitacao,
                solicitacaodocumento: arquivoRemovido,
                rotaAnexo,
                solicitacaohistorico,
                tiposubentidade: 1,
                idsubentidade: dependente.dependenteadmissaocompleta,
                estabelecimento
            })
            : this.$q.when(null);

        if (file && !file.id) {
            promise = promise.then(() => this.MeurhAnexosService.uploadAnexo({
                id: solicitacao,
                solicitacao,
                file,
                tipodocumentocolaborador: tipodocumentorequerido.tipodocumentocolaborador.tipodocumentocolaborador,
                rotaAnexo,
                solicitacaohistorico,
                tiposubentidade: 1,
                idsubentidade: dependente.dependenteadmissaocompleta,
                estabelecimento
            }));
        }

        return promise;
    }

    private trataErroDocumentosDependentes(): void {
        this.NewToaster.pop({
            type: 'error',
            title: 'A admissão foi salva, mas ocorreu um erro ao anexar documentos dos dependentes.'
        });
        this.busy = false;
    }

    private onSubmitSuccess(): void {
        this.$scope.$on('meurh_solicitacoesadmissoesestagiario_submitted', (event: angular.IAngularEvent, args: any): void => {
            try {
                this.entityService.constructors.solicitacao = args.entity.solicitacao;
                this.entityAnexo['solicitacao'] = args.entity.solicitacao;
                this.entityAnexo['solicitacaohistorico'] = args.response.data.solicitacaohistorico;
                this.entityAnexo['casodeuso'] = 'solicitacoesadmissoesestagiario';
                this.constructors.solicitacao = args.entity.solicitacao;
                this.$rootScope.$broadcast('meurh_todas_solicitacoes_submitted', {});

                const isEdicaoWorkflowAtivo = args.entity.situacao === this.situacaoAdmissaoEnum.ENVIADA &&
                    (args.entity._editavel && args.entity._acoes.length) as boolean;

                const tituloToast = args.entity.situacao === this.situacaoAdmissaoEnum.ABERTA || isEdicaoWorkflowAtivo
                    ? 'A admissão foi editada com sucesso.'
                    : 'A admissão foi enviada com sucesso.';

                if (
                    this.tiposdocumentosrequeridos.length <= 0 ||
                    this.alterouanexo === false
                ) {

                    this.uploadDocumentosDependentes(args.entity.solicitacao, args.response.data.solicitacaohistorico)
                        .then(() => {
                            this.NewToaster.pop({
                                type: 'success',
                                title: tituloToast
                            });

                            this.$state.go('meurh_admissaoestagiario_show', this.constructors);
                        })
                        .catch(() => this.trataErroDocumentosDependentes());
                } else {
                    this.$scope.$on('meurh_todas_solicitacoes_documentos_complete', () => {
                        this.$scope.$apply();
                        if (
                            this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => tipodocumentorequerido.validateResult) &&
                            !this.documentosValidados
                        ) {
                            this.documentosValidados = true;

                            this.uploadDocumentosDependentes(args.entity.solicitacao, args.response.data.solicitacaohistorico)
                                .then(() => {
                                    this.NewToaster.pop({
                                        type: 'success',
                                        title: tituloToast
                                    });

                                    this.$state.go('meurh_admissaoestagiario_show', this.constructors);
                                })
                                .catch(() => this.trataErroDocumentosDependentes());
                        }
                    });
                }
            } catch (error) {
                const message = error.message ? error.message : null;

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Ocorreu um erro',
                    body: message
                });

                this.busy = false;
                this.$state.go('meurh_admissaoestagiario_show', this.constructors);
            }
        });
    }

    private onSubmitError(): void {
        this.$scope.$on('meurh_solicitacoesadmissoesestagiario_submit_error', (event: angular.IAngularEvent, args: any): void => {
            let mensagemErro = '';
            const tituloErro = args.entity.situacao === -1
                ? 'Não foi possível editar a admissão'
                : 'Não foi possível enviar a admissão';

            try {
                if (!!args.response && !!args.response.data) {
                    if (!!args.response.data.errors && !!args.response.data.errors.children) {

                        // caso seja um array
                        if (Array.isArray(args.response.data.errors.children)) {
                            args.response.data.errors.children.forEach((element: any) => {
                                mensagemErro = mensagemErro + '&bull; ' + element + '<br>';
                            });
                        } else {
                            // caso seja um objeto
                            for (const campo in args.response.data.errors.children) {
                                if (args.response.data.errors.children[campo]['errors']) {
                                    args.response.data.errors.children[campo]['errors'].forEach((element: string) => {
                                        mensagemErro = mensagemErro + '&bull; ' + element + '<br>';
                                    });
                                }
                            }
                        }

                    } else if (args.response.data && args.response.data.message) {
                        mensagemErro = '&bull; ' + args.response.data.message + '<br>';
                    }
                }

                this.NewToaster.pop({
                    type: 'error',
                    title: tituloErro,
                    body: mensagemErro,
                    bodyOutputType: 'trustedHtml'
                });
            } catch (error) {
                const message = error.message ? error.message : null;

                this.NewToaster.pop({
                    type: 'error',
                    title: tituloErro,
                    body: message
                });
            } finally {
                this.busy = false;
            }
        });
    }
    // fim - observers


    // inicio - tratamentos de dados
    private alteraEntityInicio(): void {
        // dados gerais
        this.entity.unidadebolsa = this.entity.unidadebolsa
            ? this.entity.unidadebolsa.toString()
            : this.entity.unidadebolsa;
        this.entity.atividade = this.entity.atividade
            ? this.entity.atividade.toString()
            : this.entity.atividade;

        // contrato
        this.entity.tipoatividade = this.entity.tipoatividade
            ? this.entity.tipoatividade.toString()
            : this.entity.tipoatividade;
        this.entity.tiporegimetrabalhista = this.entity.tiporegimetrabalhista
            ? this.entity.tiporegimetrabalhista.toString()
            : this.entity.tiporegimetrabalhista;

        // dados pessoais
        this.entity.sexo = this.entity.sexo
            ? this.entity.sexo.toString()
            : this.entity.sexo;
        this.entity.estadocivil = this.entity.estadocivil
            ? this.entity.estadocivil.toString()
            : this.entity.estadocivil;
        this.entity.grauinstrucao = this.entity.grauinstrucao
            ? this.entity.grauinstrucao.grauinstrucao
            : null;

        // documentacao
        this.entity.categoriacnh = this.entity.categoriacnh
            ? this.entity.categoriacnh.toString()
            : this.entity.categoriacnh;

        // outras informacoes
        this.entity.agencianumero = this.entity.agencia ? this.entity.agencia.agencianumero : this.entity.agencianumero;
        this.entity.tiporecebimentobolsa = (
            this.entity.tiporecebimentobolsa !== undefined &&
            this.entity.tiporecebimentobolsa !== null
        )
            ? this.entity.tiporecebimentobolsa.toString()
            : this.entity.tiporecebimentobolsa;
        this.entity.nivelestagio = this.entity.nivelestagio
            ? this.entity.nivelestagio.toString()
            : this.entity.nivelestagio;

        this.entity.tipocontapix = this.entity.tiporecebimentobolsa === '64' && this.entity.tipocontapix ? this.entity.tipocontapix.toString() : null;
        this.entity.percentualadiantamento /= 100;

        // dependentes
        if (this.entity.dependentes && this.entity.dependentes.length > 0) {
            this.entity.dependentes.forEach((element: any) => {
                element.percentualpensaoalimenticia /= 100;
                element.percentualpensaoalimenticiafgts /= 100;
            });
        }

        this.entity.temporesidenciaestrangeiro = !!this.entity.temporesidenciaestrangeiro ? this.entity.temporesidenciaestrangeiro.toString() : this.entity.temporesidenciaestrangeiro;
        this.entity.classificacaoestrangeiro = !!this.entity.classificacaoestrangeiro ? this.entity.classificacaoestrangeiro.toString() : this.entity.classificacaoestrangeiro;
    }

    private alteraEntityEnviar(rascunho: boolean = false): void {
        this.entitySave = angular.copy(this.entity);
        if (this.entity.situacao === this.situacaoAdmissaoEnum.ENVIADA && this.entity._editavel) {
            this.entitySave.situacao = this.situacaoAdmissaoEnum.ENVIADA;
        } else {
            this.entitySave.situacao = rascunho ? -1 : 0;
        }

        if (!this.entitySave.horarionoturnojornadasemanal) {
            this.entitySave.horarionoturnojornadasemanal = true;
        }

        this.entitySave.gestores = [];
        if (this.entity.gestores) {
            this.entity.gestores.map((gestor: IGestoresTrabalhador) => {
                if (gestor.gestor) {
                    this.entitySave.gestores?.push({ 'gestor': gestor.gestor });
                } else {
                    this.entitySave.gestores?.push({ 'identificacaonasajongestor': gestor.email });
                }
            });
        }
        this.entitySave.gestores = JSON.stringify(this.entitySave.gestores);

        this.entitySave.vaga = this.entitySave.vaga
            ? this.entitySave.vaga.vaga
            : null;
        this.entitySave.estabelecimento = this.entitySave.estabelecimento
            ? this.entitySave.estabelecimento.estabelecimento
            : null;

        this.entitySave.ambiente = !!this.entitySave.ambiente
            ? this.entitySave.ambiente.ambiente
            : null;

        this.entitySave.condicaoambientetrabalho = this.entitySave.condicaoambientetrabalho
            ? this.entitySave.condicaoambientetrabalho.condicaoambientetrabalho
            : null;

        this.entitySave.nivelcargo = this.entitySave.nivelcargo
            ? this.entitySave.nivelcargo.nivelcargo
            : null;
        this.entitySave.departamento = this.entitySave.departamento
            ? this.entitySave.departamento.departamento
            : null;
        this.entitySave.lotacao = this.entitySave.lotacao
            ? this.entitySave.lotacao.lotacao
            : null;
        this.entitySave.grupodeponto = this.entitySave.grupodeponto
            ? this.entitySave.grupodeponto.grupo
            : null;
        this.entitySave.horario = this.entitySave.horario
            ? this.entitySave.horario.horario
            : null;
        this.entitySave.categoriatrabalhador = this.entitySave.categoriatrabalhador
            ? this.entitySave.categoriatrabalhador.categoriatrabalhador
            : null;
        this.entitySave.municipionascimento = this.entitySave.municipionascimento
            ? this.entitySave.municipionascimento.ibge
            : null;
        this.entitySave.paisnascimento = this.entitySave.paisnascimento
            ? this.entitySave.paisnascimento.pais
            : null;
        this.entitySave.paisnacionalidade = this.entitySave.paisnacionalidade
            ? this.entitySave.paisnacionalidade.pais
            : null;
        this.entitySave.raca = this.entitySave.raca
            ? this.entitySave.raca.raca
            : null;
        this.entitySave.tipologradouro = this.entitySave.tipologradouro
            ? this.entitySave.tipologradouro.tipologradouro
            : null;
        this.entitySave.municipio = this.entitySave.municipio
            ? this.entitySave.municipio.ibge
            : null;
        this.entitySave.pais = this.entitySave.pais
            ? this.entitySave.pais.pais
            : null;
        if (this.entitySave.numerohorasmensais !== undefined && this.entitySave.numerohorasmensais !== null) {
            this.entitySave.numerohorasmensais = String(this.entitySave.numerohorasmensais).replace(',', '.');
        }
        if (this.entitySave.quantidademediahorassemanais !== undefined && this.entitySave.quantidademediahorassemanais !== null) {
            this.entitySave.quantidademediahorassemanais = String(this.entitySave.quantidademediahorassemanais).replace(',', '.');
        }
        this.entitySave.percentualadiantamento *= 100;
        this.entitySave.instituicaoensino = this.entitySave.instituicaoensino
            ? this.entitySave.instituicaoensino.instituicao
            : null;
        this.entitySave.instituicaointegradora = this.entitySave.instituicaointegradora
            ? this.entitySave.instituicaointegradora.instituicao
            : null;

        this.entitySave.datainiciocontrato = this.entitySave.datainiciocontrato
            ? moment(this.entitySave.datainiciocontrato).format('YYYY-MM-DD')
            : null;
        this.entitySave.inicioperiodoaquisitivoferias = this.entitySave.inicioperiodoaquisitivoferias
            ? moment(this.entitySave.inicioperiodoaquisitivoferias).format('YYYY-MM-DD')
            : null;
        this.entitySave.dataexpedicaorg = this.entitySave.dataexpedicaorg
            ? moment(this.entitySave.dataexpedicaorg).format('YYYY-MM-DD')
            : null;
        this.entitySave.dataexpedicaoctps = this.entitySave.dataexpedicaoctps
            ? moment(this.entitySave.dataexpedicaoctps).format('YYYY-MM-DD')
            : null;
        this.entitySave.datafimcontrato = this.entitySave.datafimcontrato
            ? moment(this.entitySave.datafimcontrato).format('YYYY-MM-DD')
            : null;
        this.entitySave.datanascimento = this.entitySave.datanascimento
            ? moment(this.entitySave.datanascimento).format('YYYY-MM-DD')
            : null;
        this.entitySave.unidadebolsa = this.entitySave.unidadebolsa
            ? this.entitySave.unidadebolsa
            : null;

        this.entitySave.agencia = null;
        if (
            this.entitySave.tiporecebimentobolsa === undefined ||
            this.entitySave.tiporecebimentobolsa === null
        ) {
            delete this.entitySave.tiporecebimentobolsa;
            delete this.entitySave.tipocontapix;
        } else if (this.entitySave.tiporecebimentobolsa === '64') {
            this.entitySave.tipocontapix = parseInt(this.entitySave.tipocontapix, 10);
        }

        if (this.entitySave.banco) {
            this.entitySave.banco = this.entitySave.banco.banco
                ? this.entitySave.banco.banco
                : null;
        }

        // benefícios
        if (this.entitySave.beneficios) {
            this.entitySave.beneficios.forEach((element: any) => {
                element.lotacao = angular.copy(element.lotacao.lotacao);
                element.instituicao = element.instituicao
                    ? angular.copy(element.instituicao.instituicao)
                    : element.instituicao;
                if (element.usobeneficio === 2) {
                    element.cpfdependente = element.dependenteSelecionado.cpf;
                }

                if (element.usobeneficio === 1 && element.cpfdependente != null) {
                    element.cpfdependente = element.dependente = null;
                }
            });

            this.entitySave.beneficios = JSON.stringify(this.entitySave.beneficios);
        }

        // dependentes
        if (this.entitySave.dependentes) {
            this.entitySave.dependentes.forEach((element: any) => {
                element.datainclusao = element.datainclusao
                    ? element.datainclusao
                    : null;
                element.databaixaimpostorenda = element.databaixaimpostorenda
                    ? element.databaixaimpostorenda
                    : null;
                element.vencimentoescolar = element.vencimentoescolar
                    ? element.vencimentoescolar
                    : null;
                element.vencimentovacinacao = element.vencimentovacinacao
                    ? element.vencimentovacinacao
                    : null;
                element.agencia = element.agencia
                    ? angular.copy(element.agencia.agencia)
                    : element.agencia;

                element.percentualpensaoalimenticia *= 100;
                element.percentualpensaoalimenticiafgts *= 100;
                element.matricula = element.matricula.toUpperCase();
                delete element.tiposdocumentosrequeridosdependentes;
                delete element.mostrarAlertaDocumentosDependente;
                delete element.alterouanexodependente;
                delete element.busyTipoDocumentosDependente;
            });

            this.entitySave.dependentes = JSON.stringify(this.entitySave.dependentes);
        }

        // vale de transporte
        if (this.entitySave.vts) {
            this.entitySave.vts.forEach((element: any) => {
                element.tarifaconcessionariavt = angular.copy(element.tarifaconcessionariavt.tarifaconcessionariavt);
            });

            this.entitySave.vts = JSON.stringify(this.entitySave.vts);
        }

        this.entitySave.temporesidenciaestrangeiro = !!this.entitySave.temporesidenciaestrangeiro ? parseInt(this.entitySave.temporesidenciaestrangeiro, 10) : null;
        this.entitySave.classificacaoestrangeiro = !!this.entitySave.classificacaoestrangeiro ? this.entitySave.classificacaoestrangeiro : null;
    }

    private getMensagensModal(tipoMensagem: 'rascunho' | 'enviar' | 'encaminhar' | 'descartar'): object {
        const msgAlerta = !this.entity.statusprocesso || this.entity.statusprocesso === 0
            ? 'Após enviar a admissão, os dados enviados não poderão mais ser editados.'
            : 'Após enviar a admissão, os dados enviados não poderão mais ser editados e nem o futuro colaborador concluir o informe dos dados.';

        const customTexts = {
            enviar: {
                title: 'Enviar admissão',
                subtitle: msgAlerta,
                confirmText: 'Você tem certeza que deseja enviar a admissão de ' + this.entity.nome + '?',
                closeButton: 'Cancelar',
                confirmButton: 'Enviar admissão',
            },
            descartar: {
                title: 'Descartar edição',
                subtitle: 'Ao descartar, todas as alterações feitas na admissão serão perdidas.',
                confirmText: 'Tem certeza que deseja descartar a edição da admissão de ' + this.entity.nome + '?',
                closeButton: 'Voltar',
                confirmButton: 'Descartar edição',
            },
            encaminhar: {
                title: 'Encaminhar admissão',
                subtitle: 'Após a admissão ser encaminhada, os campos que o futuro colaborador pode preencher através do aplicativo ficarão bloqueados para edição até que ele conclua o preenchimento dos dados ou até que seja necessário retomar o processo de admissão.',
                confirmText: `Você tem certeza que deseja encaminhar a admissão para ${this.entity.nome}?`,
                closeButton: 'Cancelar',
                confirmButton: 'Encaminhar admissão'
            }
        };

        return customTexts[tipoMensagem];
    }

    private resetTiposDocumentosRequeridosService(): void {
        this.TiposDocumentosRequeridosService.constructors = { 'tiposolicitacao': TipoSolicitacaoEnum.ADMISSOESESTAGIARIO };
        this.TiposDocumentosRequeridosService.entities = [];
        this.TiposDocumentosRequeridosService.loadParams = {
            to_load: 3,
            busy: false,
            finished: false
        };
        this.TiposDocumentosRequeridosService.after = {};
    }

    // fim - tratamentos de dados
}
